import React, { useEffect } from "react";
import MaintenancePage from "../maintenance/MaintenancePage";

function VolunteerPlanningPage() {
  useEffect(() => {
    document.title = "志愿规划";
  }, []);
  return <MaintenancePage />;
}

export default VolunteerPlanningPage;
